import * as React from 'react';
import { Col, Row } from 'reactstrap';
import ReactQuill from 'react-quill';
import { CountryDropdown } from 'react-country-region-selector';
import { IImageStatusType, IAgency, AgencyCodeValidator } from '../../../../../share/types/agency';
import { WrappedInput } from '../../../../../share/components/Input/Input';
import { LogoDropZone } from './LogoDropZone';
import { modules, formats } from '../../../../../share/config/quill';

export interface IAgencyFormProps {
  agencyCodeValidator: (event: any) => void;
  setValue: (path: string, value: any) => void;
  logoSelected: boolean;
  imageUploadingStatus: IImageStatusType;
  agencyInfo: IAgency;
  loading: boolean;
  invalidCode: boolean;
  checkingCode: boolean;
  isEditAgency: boolean;
}

export class AgencyForm extends React.Component<IAgencyFormProps, any> {
  constructor(props: IAgencyFormProps) {
    super(props);
  }

  public render() {
    return (
      <Row>
        <Col md="6">
          <LogoDropZone
            setValue={this.props.setValue}
            logoSelected={this.props.logoSelected}
            imageUploadingStatus={this.props.imageUploadingStatus}
            agencyInfo={this.props.agencyInfo}
            loading={this.props.loading}
          />
        </Col>
        <Col md="6">
          <Row>
            <Col md="12" className="subFont">
              <WrappedInput
                type="text"
                inputinfo={this.props.checkingCode ? AgencyCodeValidator.CHECKINGCODE :
                  this.props.invalidCode ? AgencyCodeValidator.INVALIDCODE :
                    this.props.agencyInfo.code ? AgencyCodeValidator.AVAILABLECODE : ''}
                {...this.agencyCodeForm('Code', 'Enter code')}
                className="agency-code-input"
                onChange={(e) => this.props.agencyCodeValidator(e)}
                disabled={this.props.isEditAgency || this.props.loading}
                invalid={this.props.invalidCode}
              />
              <WrappedInput
                type="text"
                {...this.form('Name', 'Enter agency name')}
              />
              {this.props.isEditAgency || this.props.loading ?
                <WrappedInput
                  type="text"
                  {...this.form('Country', 'Select country')}
                  disabled={this.props.isEditAgency || this.props.loading}
                /> :
                <Col md="12">
                  <div className={`position-relative form-group`} >
                    <CountryDropdown
                      {...this.form('Country', 'Select country')}
                      classes="form-control-sm form-control"
                      onChange={(e: any) => this.props.setValue('agencyInfo.country', e)}
                    />
                  </div>
                </Col>
              }
              <WrappedInput
                type="text"
                {...this.form('ContactPerson', 'Enter contact name')}
              />
              <WrappedInput
                type="email"
                {...this.form('Email', 'Enter contact email')}
              />
              <WrappedInput
                type="text"
                {...this.form('Phone', 'Enter contact phone number')}
                required={false}
              />
              <div className="col-md-12 text-editor-contact">
                <ReactQuill
                  modules={modules}
                  formats={formats}
                  {...this.contactInfoHandler('Contact')}
                  placeholder="Contact Information"
                  className="subFont"
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
  public agencyCodeForm = (key: string, placeholder?: string) => {
    return {
      ...this.form(key, placeholder),
      onChange: (e: any) => {
        const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        this.props.setValue(`agencyInfo.${key.toLowerCase()}`, value);
      },
    }
  }
  public form = (key: string, placeholder?: string) => {
    const { agencyInfo, loading } = this.props;
    const stateValue = key.toLowerCase();

    return {
      id: key,
      name: key,
      md: 12,
      value: agencyInfo[stateValue],
      placeholder: placeholder ? placeholder : key,
      onChange: (e: any) => this.props.setValue(`agencyInfo.${stateValue}`, e.target.value),
      required: true,
      disabled: loading
    }
  }

  public contactInfoHandler(key: string) {
    const { agencyInfo } = this.props
    const stateValue = key.toLowerCase();
    return {
      id: key,
      name: key,
      md: 12,
      required: false,
      value: agencyInfo[stateValue],
      onChange: (e: any) => {
        this.props.setValue(`agencyInfo.${stateValue}`, e)
      },
    }
  }
}

export default AgencyForm;
